import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  fetchId,
  fetchRole,
  selectRole,
  selectDataId,
  editItem,
  addOfficeUser,
  selectDataIdUser,
  fetchIdUser,
  editEmployee,
  removeUserOffice,
  unlockUserUpdate,
  resetUserUpdate,
  selectRoleModal,
  fetchRoleModal,
  editOfficeUser,
} from "../user/userSlice";
import {
  checkMenu,
  dateDefault,
  formLabelsTheme,
  formatDate,
  getValueOptions,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";
import {
  editInbound,
  fetchIdInbound,
  fetchListInspection,
  fetchVehicle,
  fetchVehicleMovement,
  selectIdInbound,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectVehicle,
} from "../inbound/inboundSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {
  fetchIdMovement,
  selectIdMovement,
  selectPermissionList,
  setPermisionList,
  setPermisionMovement,
} from "./movementSlice";
import { WorkflowMovementPage } from "./WorkflowMovementPage";
import {
  fetchMenuTab,
  selectLoadingMenu,
  selectMenuTab,
} from "../menu/menuSlice";
import { ErrorPermissionPage } from "../../utility/ErrorPermissionPage";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const WorkflowMovement = (params) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdMovement);
  const data = useSelector(selectVehicle);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataService = useSelector(selectParameter);
  const dataJobType = useSelector(selectParameter2);
  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();

  const [value, setValue] = useState(0);
  const [force, setForce] = useState(false);

  const [paramFilter, setParamFilter] = useState("");
  const [paramValue, setParamValue] = useState("");

  const dataMenuTab = useSelector(selectMenuTab);
  const loadingMenu = useSelector(selectLoadingMenu);
  const dataMenuList = useSelector(selectPermissionList);

  // initial
  const dataParams = params.location.state;

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      let result;

      // if (dataParams === 0) {
      //   result = "5514,5521";
      // }

      await dispatch(fetchIdMovement(id));

      await dispatch(
        fetchMenuTab({
          menu_url: "/motor-pool/movement",
        })
      );
      setValue(dataParams);
      await dispatch(
        fetchVehicleMovement({
          movement_id: id,
          is_planned: "Y,N",
          movement_planned: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setParamValue("");
      setParamFilter("");
      setValueTab(0);
      setForce(false);
    }
  }, [force]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      dispatch(setPermisionList(data));
      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Movement") {
          return dispatch(setPermisionMovement(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  const handleSearch = async () => {
    let result;

    // if (value === 0) {
    //   result = "5514,5521";
    // }
    let params = {};
    params.movement_id = id;
    // params.movement_planned = "Y";
    params.is_planned = "Y,N";
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchVehicleMovement(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
    forceUpdate();
    setForce(true);
  };

  const [valueTab, setValueTab] = useState(0);

  const [formData, setFormData] = useState({
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    von: {
      value: "",
      error: false,
      required: "N",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
    location: {
      value: "",
      error: false,
      required: "Y",
    },
    location_name: {
      value: "",
      error: false,
      required: "N",
    },
    movement_date: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  const [show, setShow] = useState(false);
  const [showScan, setShowScan] = useState(false);

  // formVehicle
  const [getData, setGetData] = useState(false);

  const [create, setCreate] = useState(false);

  return loading || loadingMenu ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between mt-5 mb-5">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Activity Monitor
                </p>
              </div>
              <div className="d-flex justify-content-between mt-5 mb-5">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Movement Job : {dataId.movement_no}
                </p>
              </div>

              {/* Header */}

              <div
                className="m-2 d-flex bg-primary-dark align-items-center"
                style={{ borderRadius: "10px" }}
              >
                <div className="m-2 flex-fill font-weight-boldest  text-white ml-5">
                  Workflow
                </div>
              </div>
              <>
                <Tabs
                  value={value}
                  onChange={handleChangeTab}
                  indicatorColor="primary"
                  textColor="primary"
                  fullWidth
                >
                  {checkMenu(dataMenuList, "Movement") ? (
                    <Tab
                      label={`Movement : ${dataId.movement_status_workflow}`}
                    />
                  ) : (
                    <Tab
                      disabled
                      label={`Movement : You Dont Have Permission >`}
                    />
                  )}
                </Tabs>
                {value === 0 && (
                  <>
                    {checkMenu(dataMenuList, "Movement") ? (
                      <WorkflowMovementPage
                        active={value}
                        paramFilter={paramFilter}
                        setParamFilter={setParamFilter}
                        paramValue={paramValue}
                        setParamValue={setParamValue}
                        value={valueTab}
                        setValue={setValueTab}
                        formValues={formData}
                        setFormValues={setFormData}
                        show={show}
                        setShow={setShow}
                        showScan={showScan}
                        setShowScan={setShowScan}
                        getData={getData}
                        setGetData={setGetData}
                        create={create}
                        setCreate={setCreate}
                      />
                    ) : (
                      <ErrorPermissionPage />
                    )}
                  </>
                )}
              </>
            </CardBody>
          </Card>
        </>
      )}
    </>
  );
};
